module.exports = __webpack_public_path__ + "img/map_bg.7aa1ee53.png";